module.exports = __webpack_public_path__ + "0cb1238e9dcc09b7100e82d737aabd25.svg";